export default (
  state = {
    metaFields: [],
    globalMetaFields: [],
    metaGroups: [],
  },
  action,
) => {
  switch (action.type) {
    /*
    =============================================
        Meta Fields Data for Document / Template
    =============================================
    */
    case "ADD_META_FIELD": {
      const { docMode, metaFieldInfo, metaGroupData } = action.payload;
      const { metaGroups } = state;
      const addedLevel = docMode === "documents" ? "DOCUMENT" : "TEMPLATE";
      let updatedMetaGroups = [];
      // if (
      //   Array.isArray(metaGroups) &&
      //   metaGroups.length < addedLevel === "DOCUMENT"
      //     ? 2
      //     : 1
      // ) {
      //   updatedMetaGroups.push(...metaGroups, metaGroupData);
      if (Array.isArray(metaGroups) && metaGroups.length < 1) {
        updatedMetaGroups.push(metaGroupData);
      } else {
        updatedMetaGroups = metaGroups.map(group => {
          if (addedLevel === group.level) {
            group.meta.fields = {
              ...group.meta.fields,
              ...metaFieldInfo.fields,
            };
          }
          return group;
        });
      }

      return {
        ...state,
        metaGroups: updatedMetaGroups,
      };
    }
    // return { ...state, metaFields: action.payload };
    case "UPDATE_META_FIELD":
      return { ...state, metaFields: action.payload };
    case "DELETE_META_FIELD": {
      const { docMode, metaFieldItemName } = action.payload;
      const { metaGroups } = state;
      const addedLevel = docMode === "documents" ? "DOCUMENT" : "TEMPLATE";
      const updatedMetaGroups = metaGroups.map(group => {
        if (addedLevel === group.level) {
          delete group.meta.fields[metaFieldItemName];
        }
        return group;
      });

      return {
        ...state,
        metaGroups: updatedMetaGroups,
      };
    }
    // return { ...state, metaFields: action.payload };
    case "FETCH_META_FIELDS":
      return { ...state, metaGroups: action.payload };
    case "UPDATE_GLOBAL_META_FIELDS":
      return { ...state, metaFields: action.payload };
    case "UPDATE_TEMPLATE_META_FIELD_IN_DOC": {
      const {
        updatedMetaFieldName,
        metaGroupId,
        updatedObject: { values: updatedValue },
      } = action.payload;
      const { metaGroups } = state;
      const updatedMetaGroups = metaGroups.map(group => {
        if (metaGroupId === group.id) {
          group.meta.fields[updatedMetaFieldName].value =
            updatedValue[updatedMetaFieldName];
        }
        return group;
      });

      return {
        ...state,
        metaGroups: updatedMetaGroups,
      };
    }
    case "REACTION_ON_DOCUMENT_PAGE_LOAD":
      return { ...state, metaGroups: [] };
    default:
      return state;
  }
};
